import axios from "axios"

const cname = "utm_params="
const utmKeys = ["utm_source", "utm_campaign", "utm_medium", "utm_content"]

export function getUtmParams(location) {
  if (location) {
    const utmParams = location.substring(1)
    const params = Object.fromEntries(new URLSearchParams(utmParams))
    if (isUTMParams(params)) {
      document.cookie = cname + JSON.stringify(params) + "; path=/"
    }
  }
}

export function extractCookie(cname) {
  const cookieValue = document.cookie
    .split("; ")
    .find(row => row.startsWith(cname))
    ?.split("=")[1]

  if (cookieValue) {
    return JSON.parse(cookieValue)
  } else {
    return {}
  }
}

function checkACookieExists(cname) {
  return document.cookie.split(";").some(item => item.trim().startsWith(cname))
}

function isUTMParams(param) {
  const keys = Object.keys(param)
  return utmKeys.some(item => keys.includes(item))
}

function deleteUtm(cname) {
  document.cookie = cname + "; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/"
}

export async function submitUtm(params) {
  const utmParams = extractCookie(cname)
  const kaptureData = {
    ...utmParams,
    ...params,
    website: "www.bsdcity.com",
    country_code: "ID",
  }

  const config = {
    method: "POST",
    url: "https://www.bsdcity.com/submit-utm",
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Basic ZGpma3o2dmVidmo5MTN1ZHhiaDI3eTZ4dHcwdjVvMTN1dThzZ3FtaHMwc21tOXJnMjI=",
    },

    data: kaptureData,
  }

  const res = await axios(config)
  deleteUtm(cname)
  console.log(res)
}

/**
 * Extracts search parameters from a URL string and returns them as an object
 * @param {string} url - The URL string or query string to parse
 * @returns {Object} An object containing the search parameters
 */
export function extractSearchParams(url) {
  // Handle both full URLs and query strings
  const queryString = url.includes('?') ? url.split('?')[1] : url;
  
  // Return empty object if no query string
  if (!queryString) return {};
  
  // Use URLSearchParams API for robust parsing
  const params = new URLSearchParams(queryString);
  const result = {};
  
  // Convert to plain object
  for (const [key, value] of params.entries()) {
    // Handle multiple values for same key
    if (result.hasOwnProperty(key)) {
      // Convert to array if multiple values exist
      result[key] = Array.isArray(result[key]) 
        ? [...result[key], value]
        : [result[key], value];
    } else {
      result[key] = value;
    }
  }
  
  return result;
}
